<template>
    <div>
        <div>
            <div :style="radioDiv">
                <b>保函类型选择</b>
                <el-radio-group
                    v-model="raidoForm.bhlx"
                    :style="radioGroupStyle"
                    @change="radioChange"
                >
                    <el-radio-button
                        v-for="(item, index) in bhlx"
                        :label="item.valueid"
                        :key="index"
                    >{{item.valuename}}</el-radio-button>
                    <!-- <el-radio-button v-for="item in guaranteeTypes" :label="item.value">{{item.label}}</el-radio-button> -->
                </el-radio-group>
            </div>

            <el-row :style="radioDiv">
                <b>出函机构选择</b>
                <el-radio-group
                    v-model="raidoForm.chjg"
                    :style="radioGroupStyle"
                    @change="radioChange"
                >
                    <el-radio-button
                        v-for="(item, index) in chjg"
                        :label="item.valueid"
                        :key="index"
                    >{{item.valuename}}</el-radio-button>
                </el-radio-group>
            </el-row>
            <el-row :style="radioDiv">
                <el-col :span="2">
                    <b>预计出函时间:</b>
                </el-col>
                <el-col :span="22">
                    <span style="color:#f18241;font-weight:bold;">{{expectTime}}</span>
                </el-col>
            </el-row>
            <div style="margin:20px 0;text-align:center;"><el-button
                    size="small"
                    @click="doHandler"
                    type="primary"
                >立即办理</el-button></div>
        </div>

        <my-form
            v-model="form"
            style="width:1000px; margin:1em auto;"
            label-width="110px"
            v-if="bhlxSelect == 'tbbh'"
        >
            <el-row :gutter="40">
                <el-col
                    :span="24"
                    v-if="!vendorInfo.price"
                >
                    <el-steps
                        :active="0"
                        align-center
                        style="margin-top:50px;"
                    >
                        <el-step
                            title="第一步"
                            description="选择保函种类"
                        ></el-step>
                        <el-step
                            title="第二步"
                            description="填写保函信息"
                        ></el-step>
                        <el-step
                            title="第三步"
                            description="支付"
                        ></el-step>
                        <el-step
                            title="第四步"
                            description="出函"
                        ></el-step>
                    </el-steps>
                </el-col>

                <transition name="el-zoom-in-center">
                    <el-col
                        :span="12"
                        v-if="vendorInfo.price"
                    >
                        <el-card class="order-invite">
                            <h2 style="margin-bottom:3em;">办理邀请</h2>
                            <el-form-item
                                label="支付金额："
                                style="position:relative;"
                            >
                                <div>
                                    <h1 class="price-h1">
                                        ￥<span style="color:red;">{{vendorInfo.price}}</span>元
                                    </h1>
                                    <span
                                        class="price-ord"
                                        v-if="form.guaranteetype != '公司保函' && vendorInfo.price != 0"
                                    >
                                        原价：{{vendorInfo.price * 2}}元
                                    </span>
                                </div>
                            </el-form-item>
                            <el-button
                                type="danger"
                                @click="doHandler"
                                style="width:80%; display:block; margin:0 auto;"
                            >立即办理</el-button>
                        </el-card>
                    </el-col>
                </transition>
            </el-row>

            <div slot="btn"></div>
        </my-form>

        <el-dialog
            width="30%"
            title="选择担保公司"
            :visible.sync="vendorVisible"
            append-to-body
        >
            <div style="margin-top: 40px;width: 100%;display: flex;flex-wrap: wrap;justify-content: space-between;">
                <div
                    @click="selectVendor(item,index)"
                    style="padding: 5px;border: 1px dashed gray;margin-right: 5px;width: 45%;margin-top: 15px;"
                    v-for="(item,index) in vendorList"
                    :class="index == curindex ? 'action' : ''"
                    :key="index"
                >
                    {{item.vendorname}}
                </div>
            </div>
            <div style="text-align: center;margin-top: 50px;">
                <el-button
                    type="primary"
                    @click="confirmVendor"
                >确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    inject: ['webInfo'],
    props: {},
    data: function () {
        return {
            curindex: 0,
            vendorVisible: false,
            curVendorinfo: {},
            vendorList: [],
            expectTime: '',
            chjg: [],
            bhlx: [],
            raidoForm: {
                chjg: '',
                bhlx: '',
            },
            radioGroupStyle: {
                display: 'inlineBlock',

                margin: '0 auto',
            },
            radioDiv: {
                lineHeight: '50px',
                marginTop: '10px',
            },

            form: {
                guaranteetype: '',
                earnest: '',
                vtype: 'bht',
            },
            vendorInfo: {
                vendorname: '-',
                price: 0,
            },

            iconArrowStyle: {
                display: 'block',
                margin: '0 auto',
                height: '368px',
            },

            priceInfo: {
                fontSize: '15px',
            },
        };
    },
    computed: {
        chjgSelect: function () {
            return this.raidoForm.chjg;
        },
        bhlxSelect: function () {
            return this.raidoForm.bhlx == '' ? 'tbbh' : this.raidoForm.bhlx;
        },
    },
    watch: {
        chjgSelect: {
            handler: function (n, o) {
                if (n == 'yhjg' && this.raidoForm.bhlx == 'lybh') {
                    this.expectTime = '3-4个工作日';
                } else if (n == 'yhjg' && this.raidoForm.bhlx != 'lybh') {
                    this.expectTime = '2个工作日';
                } else {
                    this.expectTime = '1个工作日';
                }
            },
        },
        bhlxSelect: {
            handler: function (n, o) {
                if (n == 'lybh' && this.raidoForm.chjg == 'yhjg') {
                    this.expectTime = '3-4个工作日';
                } else if (n == 'tbbh' && this.raidoForm.chjg == 'yhjg') {
                    this.expectTime = '2个工作日';
                } else {
                    this.expectTime = '1个工作日';
                }
            },
        },
    },
    methods: {
        selectVendor: function (item, index) {
            this.curindex = index;
            this.curVendorinfo = item;
        },
        confirmVendor: function () {
            if (this.curVendorinfo.vendorid == 'E000000tianan') {
                window.location.href = '/web/guarantee/tianan/form.html';
            } else {
                window.location.href = '/web/guarantee/zhonghua/form.html';
            }
        },
        earnestInput: function () {
            if (typeof this.form.earnest !== 'number') {
                this.form.earnest = 0;

                ShowMsg('保额必须为纯数字', 'error');
            }
        },
        callPrice: function () {
            var that = this;
            if (this.raidoForm.chjg == '') {
                this.$message({
                    message: '请先选择出函机构',
                    type: 'warning',
                });
            } else if (this.raidoForm.bhlx == '') {
                this.$message({
                    message: '请先选择保函类型',
                    type: 'warning',
                });
            } else {
                if (this.form.earnest > 80 && this.raidoForm.chjg != 'dbjg') {
                    this.$message({
                        message: '投标保函保额最大为80万元',
                        type: 'warning',
                    });
                    this.form.earnest = 80;
                } else {
                    this.raidoForm.earnest = this.form.earnest;
                    this.$post(
                        `${this.$store.state.api.baseUrl}/webinfo/computeprice.json`,
                        this.raidoForm,
                        function (data) {
                            that.vendorInfo.price = data;
                        }
                    );
                }
            }
            //this.selectedType.priceCaller.call(this);
        },
        clearPrice: function () {
            this.vendorInfo.price = null;
        },
        doHandler: function () {
            var that = this;

            if (
                !this.$store.getters['userinfo/loginStatus'] ||
                !window.sessionStorage.getItem('mobile')
            ) {
                this.$message({
                    message: '请先登录',
                    type: 'warning',
                });

                return;
            }

            if (this.raidoForm.chjg == '') {
                this.$message({
                    message: '请先选择出函机构',
                    type: 'warning',
                });
            } else if (this.raidoForm.bhlx == '') {
                this.$message({
                    message: '请先选择保函类型',
                    type: 'warning',
                });
            } else {
                this.$post(
                    `${this.$store.state.api.baseUrl}/commonreq/bhbltd.json`,
                    this.raidoForm,
                    function (data) {
                        if (!data) {
                            that.$message('暂未开通此保函类型办理通道');
                        } else {
                            if (
                                that.raidoForm.chjg == 'bxjg' &&
                                that.raidoForm.bhlx == 'tbbh'
                            ) {
                                //跳转保险界面
                                this.$post(
                                    `${this.$store.state.api.baseUrl}/commonreq/vendordeal.json`,
                                    {
                                        //担保公司信息
                                        guaranteetype: that.raidoForm.bhlx,
                                        agencytype: that.raidoForm.chjg,
                                        vtype: 'bht',
                                    },
                                    function (data) {
                                        that.vendorVisible = true;
                                        that.vendorList = data;
                                        that.curVendorinfo = data[0];
                                    }
                                );
                            } else {
                                //非保险界面
                                sessionStorage.setItem(
                                    'chjg',
                                    that.raidoForm.chjg
                                );
                                sessionStorage.setItem(
                                    'bhlx',
                                    that.raidoForm.bhlx
                                );
                                window.location.href =
                                    '/web/all/all.html?earnest=' +
                                    this.form.earnest;
                            }
                        }
                    }
                );
            }

            setSession('$indexApply', this.vendorInfo);
            this.$emit('apply', this.vendorInfo);
        },
        radioChange: function (e) {
            if (this.vendorInfo.price) {
                this.callPrice();
            }
        },
        getSjzd: function (typecode) {
            //获取字典中的字段
            var that = this;
            this.$post(
                `${this.$store.state.api.baseUrl}/commonreq/getdictinfo.json`,
                { typecode: typecode },
                function (data) {
                    that[typecode] = data;
                }
            );
        },
    },
    mounted: function () {
        this.getSjzd('chjg');
        this.getSjzd('bhlx');
    },
};
</script>

<style lang="scss" scoped>
.action {
    border: 2px solid #f18241 !important;
    color: #f18241;
}
</style>